const parseToLibrary = biblioteca => {
    if (!biblioteca) return null;
    const { 
        servicioPrestamo,
        tipoBloqueo 
    } = biblioteca;
    return {
        resourceType: {
            id: servicioPrestamo.id,
            name: servicioPrestamo.nombre
        },
        block: tipoBloqueo && {
            id: tipoBloqueo.id,
            name: tipoBloqueo.nombre
        }
    };
}
const parseToUniversitySpace = polideportivo => {
    if (!polideportivo) return null;
    const { espacio } = polideportivo;
    return {
        spaceName: espacio.nombre
    };
}
export const parseToStudentPenaltyAdmin = ({
    idSancion,
    codigoEstudiante,
    nombre, moduloRecurso, 
    biblioteca, polideportivo,
    fechaInicio, fechaFin,
    motivo, diasSancion, detalles
}) => {
    return {
        id: idSancion,
        student: {
            id: codigoEstudiante,
            name: nombre
        },
        date: {
            start: fechaInicio,
            end: fechaFin
        },
        reasonForPenalize: {
            id: motivo.id,
            name: motivo.nombre
        },
        resourceModule: {
            id: moduloRecurso.id,
            name: moduloRecurso.nombre
        },
        library: parseToLibrary(biblioteca),
        universitySpace: parseToUniversitySpace(polideportivo),
        penalizeDays: diasSancion,
        details: detalles
    }
}
const parseToChanges = obj => {
    if (!obj)
        return null;
    const {
        dias, fin,
        detalles
    } = obj;
    return {
        penalizeDays: dias,
        endDate: fin,
        details: detalles
    };
}
export const parseToChangeHistoryItem = ({
    dias,
    fin,
    detalles, 
    fecha, hora,
    cambios
}) => ({
    penalizeDays: dias, 
    endDate: fin,
    details: detalles,
    date: fecha,
    time: hora,
    changes: parseToChanges(cambios)
});